module.exports = __webpack_public_path__ + "img/case4.c3b580ff.png";